import React from 'react'
import { required } from 'react-admin'
import { drinkSpecialTypeChoices } from 'services/cfg/form'
import ProductSectionForm, {
  ProductSectionFormProps,
} from 'ui-shared/Forms/ProductSectionForm'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

type DrinkSectionFormProps = Omit<ProductSectionFormProps, 'entity'>

const DrinkSectionForm: React.FC<DrinkSectionFormProps> = (props) => (
  <ProductSectionForm
    {...props}
    canAssignProductToMultipleSections={false}
    entity="drinks"
  >
    <KSelectInput
      source="specialType"
      choices={drinkSpecialTypeChoices}
      validate={required()}
    />
  </ProductSectionForm>
)

export default DrinkSectionForm
